module.exports = __webpack_public_path__ + "img/磙子营乡.4aad49de.png";